import { createContext, useContext } from 'react';
import type { BrandConfig } from '@kitup/brand';

/**
 * The brand arrives from the app entry point and is then available to the whole tree.
 * There is deliberately no default value: an app cannot be built without a brand,
 * and it is better to learn that at first render than to show someone else's name.
 */
export const BrandContext = createContext<BrandConfig | null>(null);

export function useBrand(): BrandConfig {
  const brand = useContext(BrandContext);
  if (!brand) throw new Error('BrandProvider is missing above this component in the tree');
  return brand;
}
